export default "__VITE_ASSET__DnuZCBdH__"